import BlockPageStore from 'store/modules/Pages/BlockPage'
import store from 'definitions/store'

const Init = {
  init(name) {
    if (!store[name]) {
      store.registerModule(name, BlockPageStore)

      Init.initDefaultValues(name)
    }
  },

  initDefaultValues(name) {

    if (typeof pageData !== "undefined") {
      store.commit(`${name}/setPageData`, pageData)
    }
  }
}

export default Init
